module.exports = {
  eventCategory: 'Editor UI | Top Menu',

  saveEvent: { eventAction: 'save' },
  shareEvent: { eventAction: 'share', eventLabel: 'show' },
  versionsEvent: { eventAction: 'versions', eventLabel: 'show' },
  downloadEvent: { eventAction: 'download', eventLabel: 'show' },
  printEvent: { eventAction: 'print' },
  closeEvent: { eventAction: 'close' },

  redoEvent: function (event) {
    this.trackEvent({ eventAction: 'redo' });
  },

  undoEvent: function (event) {
    this.trackEvent({ eventAction: 'undo' });
  }
};
